var BitmapImageChannel = /** @class */ (function () {
    function BitmapImageChannel() {
    }
    BitmapImageChannel.ALPHA = 8;
    BitmapImageChannel.BLUE = 4;
    BitmapImageChannel.GREEN = 2;
    BitmapImageChannel.RED = 1;
    return BitmapImageChannel;
}());
export { BitmapImageChannel };
